'use strict';
angular.module('vpComponentsModule', ['uiComponentsModule']);